import React from 'react';
import PropTypes from 'prop-types';
import { useRouteMatch } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Breadcrumb } from '@paygreen/paygreen-ui';

const AdminUserBreadCrumb = ({ t, accountId }) => {
    const isClimateBilling = !!useRouteMatch(
        '/admin/users/:accountId/climate-billing',
    );
    const isCharityBilling = !!useRouteMatch(
        '/admin/users/:accountId/charity-billing',
    );
    const isCharityDonations = !!useRouteMatch(
        '/admin/users/:accountId/charity-donations',
    );

    let finalCrumbs = () => {
        switch (true) {
            case isClimateBilling:
                return [
                    {
                        url: '/admin/users',
                        label: t('admin.users.title'),
                    },
                    {
                        url: `/admin/users/${accountId}`,
                        label: t('admin.user.title'),
                    },
                    {
                        url: '/',
                        label: t('admin.billing.climate.title'),
                    },
                ];
            case isCharityBilling:
                return [
                    {
                        url: '/admin/users',
                        label: t('admin.users.title'),
                    },
                    {
                        url: `/admin/users/${accountId}`,
                        label: t('admin.user.title'),
                    },
                    {
                        url: '/',
                        label: t('admin.billing.charity.title'),
                    },
                ];
            case isCharityDonations:
                return [
                    {
                        url: '/admin/users',
                        label: t('admin.users.title'),
                    },
                    {
                        url: `/admin/users/${accountId}`,
                        label: t('admin.user.title'),
                    },
                    {
                        url: '/',
                        label: t('shopDonations.title'),
                    },
                ];
            default:
                return [
                    {
                        url: '/admin/users',
                        label: t('admin.users.title'),
                    },
                    {
                        url: '',
                        label: t('admin.user.title'),
                    },
                ];
        }
    };

    return <Breadcrumb colorTheme="quaternary" elements={finalCrumbs()} />;
};

AdminUserBreadCrumb.propTypes = {
    accountId: PropTypes.string,
};

export default withTranslation('common')(AdminUserBreadCrumb);
